export const isIRPF = (type) => {
  return type.split('#')[0] === '8'
}
